var exports = {
  "kL": "xcc377c0b--8499c0--container",
  "p_": "xcc377c0b--8499c0--list",
  "AS": "xcc377c0b--8499c0--item",
  "nf": "xcc377c0b--8499c0--link",
};

module.exports = exports;
